import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from '../store';

export const initialGlobalSettings: GlobalSettings = {
  themeMode: 'dark',
  globalKeySignature: 'C',
  globalKeySignatureUsesSharps: false,
  globalScale: 'major',
  playbackIsPlaying: false,
  playbackSeekSeconds: 0,
  playbackSeekAutoplay: false,
  playbackSeekVersion: '',
  responsiveBreakpoint: 'auto',
  tempEditTheme: null,
};

const globalSettingsSlice = createSlice({
  name: 'globalSettings',
  initialState: initialGlobalSettings,
  reducers: {
    updateGlobalSetting(state, action: PayloadAction<Partial<GlobalSettings>>) {
      return { ...state, ...action.payload };
    },
    setAllGlobalSettings(state, action: PayloadAction<GlobalSettings>) {
      return { ...state, ...action.payload };
    },
  },
});

export const { updateGlobalSetting, setAllGlobalSettings } =
  globalSettingsSlice.actions;

export const selectGlobalThemeMode = (state: RootState) =>
  state.globalSettings.themeMode;

export const selectGlobalSettings = (state: RootState) => state.globalSettings;

export default globalSettingsSlice.reducer;
